import { render } from "./TourView.vue?vue&type=template&id=2d3b0900&scoped=true"
import script from "./TourView.vue?vue&type=script&lang=js"
export * from "./TourView.vue?vue&type=script&lang=js"

import "./TourView.vue?vue&type=style&index=0&id=2d3b0900&scoped=true&lang=css"

import exportComponent from "/home/walnit/Documents/AppVenture/nush-bookings-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3b0900"]])

export default __exports__